<script>
  import MInput from 'components/Inputs/Basic/MInput';
  import _ from 'lodash';
  import filterSearch from 'utils/search/filterSearch';
  _.noConflict();

  export default {
    name: 'SearchInput',
    components: {MInput},
    props: {

      // bypass component props
      ...MInput.props,

      // bypass mixin props
      ...MInput.mixins.reduce((a, m) => ({...a, ...m.props}), {})
    },
    data () {
      return {
        innerValue: ''
      };
    },
    computed: {
      filteredValue () {
        return filterSearch(this.innerValue);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler () {
          const filteredValue = filterSearch(this.value);

          // update inner value if value really changed (ignore value update if it is the same, but filtered)
          if (filteredValue !== this.filteredValue) {
            this.innerValue = this.value;
          }
        }
      }
    },
    methods: {
      handleInput (val) {
        this.innerValue = val;

        if (filterSearch(this.value) !== this.filteredValue) {
          this.$emit('input', this.filteredValue);
        }
      },
      handleBlur () {
        if (this.filteredValue === '') {
          this.innerValue = '';
        }
      }
    },
    render (createElement) {
      return createElement(
        MInput,
        {
          props: {
            ...this.$props,
            value: this.innerValue
          },
          on: {
            input: this.handleInput,
            blur: this.handleBlur
          }
        }
      );
    }
  };
</script>

